import { render } from "./theme.vue?vue&type=template&id=ca7bf692&scoped=true&lang=pug"
import script from "./theme.vue?vue&type=script&setup=true&lang=js"
export * from "./theme.vue?vue&type=script&setup=true&lang=js"

import "./theme.vue?vue&type=style&index=0&id=ca7bf692&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7bf692"]])

export default __exports__